// extracted by mini-css-extract-plugin
export default {"root":"IyFr7O","IndentedMenuButtonNSkin":"jmYZx1","indentedMenuButtonNSkin":"jmYZx1","linkElement":"MEcgLY","extra":"LAdFf5","wrapper":"jf3d4h","label":"Pn2qB8","bg":"n0t6pl"};